import { ArrowRight } from 'lucide-react';

const industries = [
  { 
    title: 'Hotels & Resorts',
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=1470&auto=format&fit=crop'
  },
  { 
    title: 'Travel & Tourism',
    image: 'https://images.unsplash.com/photo-1488085061387-422e29b40080?q=80&w=1631&auto=format&fit=crop'
  },
  { 
    title: 'Beauty & Spa',
    image: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?q=80&w=1470&auto=format&fit=crop'
  },
  { 
    title: 'Real Estate',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1470&auto=format&fit=crop'
  },
  { 
    title: 'Restaurant & F&B',
    image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=1470&auto=format&fit=crop'
  },
  { 
    title: 'Education',
    image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?q=80&w=1422&auto=format&fit=crop'
  },
  { 
    title: 'Healthcare',
    image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?q=80&w=1453&auto=format&fit=crop'
  },
  { 
    title: 'Technology',
    image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=1470&auto=format&fit=crop'
  },
  { 
    title: 'Automobile',
    image: 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?q=80&w=1583&auto=format&fit=crop'
  },
  { 
    title: 'Finance & Investment',
    image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?q=80&w=1470&auto=format&fit=crop'
  },
  { 
    title: 'Retail & Shopping',
    image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?q=80&w=1470&auto=format&fit=crop'
  },
  { 
    title: 'Entertainment',
    image: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?q=80&w=1470&auto=format&fit=crop'
  },
];

export const IndustriesSection = () => {
  return (
    <section data-testid="industries-section" className="py-24 bg-[#0a0a0a] relative overflow-hidden">
      {/* Background Glow */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl" />
      
      <div className="w-full px-4 sm:px-8 lg:px-16 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="font-google-sans text-[#D4AF37] text-sm tracking-[0.3em] uppercase mb-4">Industries We Serve</p>
          <h2 className="font-montserrat text-white font-bold mb-6" style={{ fontSize: '3rem' }}>
            Specialized in <span className="gradient-gold">20+</span> Industries
          </h2>
          <p className="font-google-sans text-[#A1A1AA] text-lg max-w-3xl mx-auto">
            Golden Tree Events organizes award ceremonies, B2B conferences, and exhibitions across diverse industries worldwide
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {industries.map((industry, index) => (
            <div
              key={index}
              data-testid={`industry-${index}`}
              className="group relative aspect-square overflow-hidden rounded-xl cursor-pointer"
            >
              {/* Image */}
              <img
                src={industry.image}
                alt={industry.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" />
              
              {/* Gold Border on Hover */}
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-[#D4AF37] rounded-xl transition-all duration-300" />
              
              {/* Content */}
              <div className="absolute inset-0 flex flex-col items-center justify-end p-4 text-center">
                <h3 className="font-montserrat text-white text-sm sm:text-base font-semibold leading-tight group-hover:text-[#D4AF37] transition-colors duration-300">
                  {industry.title}
                </h3>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <a
            href="https://goldentreeawards.com/award-nomination"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="industries-nominate"
            className="inline-flex items-center gap-3 bg-[#D4AF37] text-black font-semibold px-10 py-4 uppercase tracking-widest text-sm hover:bg-[#C5A028] transition-all duration-300 rounded-lg"
          >
            Nominate Your Company
            <ArrowRight className="w-5 h-5" />
          </a>
        </div>
      </div>
    </section>
  );
};
